import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KanziAnalyticsReportFlightStatusComponent } from './pages/kanzi-analytics-report-flight-status/kanzi-analytics-report-flight-status.component';
import { KanziAnalyticsReportRountingModule } from './kanzi-analytics-report-rounting.module';
import { KanziUiModule } from '@kanzi-apes/kanzi-ui';
import { TranslateModule } from '@ngx-translate/core';
import { KanziAnalyticsModule } from '@kanzi-apes/kanzi-analytics';
import { KanziPrimeUiModule } from '@kanzi-apes/kanzi-prime-ui';
import { KanziAnalyticsReportComponent } from './pages/kanzi-analytics-report/kanzi-analytics-report.component';

@NgModule({
  declarations: [
    KanziAnalyticsReportFlightStatusComponent,
    KanziAnalyticsReportComponent,
  ],
  imports: [
    CommonModule,
    KanziAnalyticsReportRountingModule,
    KanziUiModule,
    TranslateModule.forChild(),
    KanziAnalyticsModule,
    KanziPrimeUiModule,
  ],
})
export class KanziAnalyticsReportsModule {}
